import { boolean, nullable, number, object, string } from "superstruct";

const RewardsProgramAccountSchema = object({
    isRewardProgramAvailableForCustomer: boolean(),
    marketing: nullable(
        object({
            acceptEmail: boolean(),
            acceptSms: boolean(),
        })
    ),
    points: nullable(
        object({
            balance: number(),
            expiresAt: nullable(string()),
        })
    ),
    tier: nullable(
        object({
            currentTier: nullable(
                object({
                    id: number(),
                    title: string(),
                    image: nullable(string()),
                    pointsMultiplier: nullable(number()),
                    achievedAt: string(),
                })
            ),
            isAllowedToEarnTier: boolean(),
        })
    ),
    referral: nullable(
        object({
            referralLink: nullable(string()),
            isReferralProgramAvailableForCustomer: boolean(),
        })
    ),
});

export default RewardsProgramAccountSchema;
